__turbopack_context__.v({
  "cta": "WPrezentation-module__Y2YaSW__cta",
  "empty": "WPrezentation-module__Y2YaSW__empty",
  "media": "WPrezentation-module__Y2YaSW__media",
  "navBtn": "WPrezentation-module__Y2YaSW__navBtn",
  "navNext": "WPrezentation-module__Y2YaSW__navNext",
  "navPrev": "WPrezentation-module__Y2YaSW__navPrev",
  "overlay": "WPrezentation-module__Y2YaSW__overlay",
  "progress": "WPrezentation-module__Y2YaSW__progress",
  "progressFill": "WPrezentation-module__Y2YaSW__progressFill",
  "root": "WPrezentation-module__Y2YaSW__root",
  "slide": "WPrezentation-module__Y2YaSW__slide",
  "slideLink": "WPrezentation-module__Y2YaSW__slideLink",
  "subtitle": "WPrezentation-module__Y2YaSW__subtitle",
  "title": "WPrezentation-module__Y2YaSW__title",
});
